import { useEffect, useState } from 'react';

export const useIsOffline = () => {
  const [isUserOffline, setIsUserOffline] = useState(false);

  const onlineEventHandler = () => {
    setIsUserOffline(false);
    return isUserOffline;
  };

  const offlineEventHandler = () => {
    setIsUserOffline(true);
    return isUserOffline;
  };

  useEffect(() => {
    if (!navigator.onLine) {
      setIsUserOffline(true);
    }

    window.addEventListener('online', onlineEventHandler);

    window.addEventListener('offline', offlineEventHandler);

    return () => {
      window.removeEventListener('online', onlineEventHandler);
      window.removeEventListener('offline', offlineEventHandler);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return isUserOffline;
};
